import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M2.5 7a.5.5 0 0 1-.5-.5V2.501a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5V6.5a.5.5 0 0 1-.5.5zm7 0a.5.5 0 0 1-.5-.5V2.501a.5.5 0 0 1 .5-.5h3.999a.5.5 0 0 1 .5.5V6.5a.5.5 0 0 1-.5.5zm-7 7a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5zm7 0a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5h3.999a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5z"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })